module.exports = __webpack_public_path__ + "static/media/bag-tag-bg.0a1823aa.png";